export const urlAndDocumentFolder = [
  { url: "uttar-pradesh", documentFolder: "Uttar Pradesh" },
  { url: "telangana", documentFolder: "Telengana" },
  { url: "tamil-nadu", documentFolder: "Tamil Nadu" },
  { url: "rajasthan", documentFolder: "Rajasthan" },
  { url: "punjab", documentFolder: "Punjab" },
  { url: "orissa", documentFolder: "Orissa" },
  { url: "mizoram", documentFolder: "Mizoram" },
  { url: "kerala", documentFolder: "Karela" },
  { url: "maharashtra", documentFolder: "Maharastra" },
  { url: "jharkhand", documentFolder: "Jahrkhand" },
  { url: "haryana", documentFolder: "Haryana" },
  { url: "gujrat", documentFolder: "Gujrat" },
  { url: "goa", documentFolder: "Goa" },
  { url: "delhi", documentFolder: "Delhi" },
  { url: "chhattisgarh", documentFolder: "Chattisgarh" },
  { url: "bihar", documentFolder: "Bihar" },
  { url: "andhra-pradesh", documentFolder: "Andhra Pradesh" }
];
